/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { Body_transcribe_audio_api_v1_transcribe_post } from "../models/Body_transcribe_audio_api_v1_transcribe_post";
import type { DataMessageResponse_TranscriptionResponse_ } from "../models/DataMessageResponse_TranscriptionResponse_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class TranscribeService {
  /**
   * Transcribe Audio
   * Transcribe a short audio clip into text using AssemblyAI Universal-3 Pro.
   *
   * Used by the mobile app's mic-to-text input: the client records a voice note,
   * POSTs the bytes here, and drops the returned text into the chat input field
   * for the user to edit and submit.
   *
   * ## Parameters:
   * - **audio**: Audio file (m4a/mp3/aac/wav/ogg/webm/mp4, max 4 MB ≈ 2 minutes)
   *
   * ## Returns:
   * - **text**: Transcribed text
   * - **audio_duration_seconds**: Duration of the submitted audio
   *
   * ## Example:
   * ```bash
   * curl -X POST "http://localhost:5000/api/v1/transcribe" \
   * -H "x-api-key: your_api_key" \
   * -H "Authorization: Bearer your_token" \
   * -F "audio=@voice_note.m4a"
   * ```
   * @param formData
   * @returns DataMessageResponse_TranscriptionResponse_ Successful Response
   * @throws ApiError
   */
  public static transcribeAudioApiV1TranscribePost(
    formData: Body_transcribe_audio_api_v1_transcribe_post,
  ): CancelablePromise<DataMessageResponse_TranscriptionResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/transcribe",
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
